import type { Notification } from '@/types'

export interface NotificationsState {
  notifications: Notification[]
  isLoading: boolean
  error: string | null
  isSubscribed: boolean
}

export const initialState: NotificationsState = {
  notifications: [],
  isLoading: false,
  error: null,
  isSubscribed: false,
}

export function resetState(): NotificationsState {
  return { ...initialState, notifications: [] }
}
